import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useNavigate, useParams } from "react-router-dom";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

import { API } from "../../api";
import { useUser } from "../../hooks/useUser";
import { getImageUrl } from "../../utils/getImageUrl";
import { UnclearBlock } from "../Feedback/UnclearBlock";
import { GratitudeBlock } from "../Feedback/GratitudeBlock";
import { SuccessBlock } from "../Feedback/SuccessBlock";
import { getBlockUrl } from "../../utils/getBlockUrl";
import { ComplaintBlock } from "../Feedback/ComplaintBlock";
import { IButton, IStep, StepType } from "../../types";
import { useStore } from "../../utils/store";
import { ContentTable } from "./ContentTable";

export const Step = () => {
  const [data, setData] = useState<IStep | null>(null);
  const [type, setType] = useState<StepType>("step");
  const [unclear, setUnclear] = useState(false);

  const { article_id, step_id } = useParams();

  const history = useNavigate();

  const clickHandler = async (button: IButton) => {
    if (article_id && data) {
      if (button.next_article) {
        history(button.next_article);
      } else {
        await API.addHistory({
          article_id,
          step_id: button.next_step_id,
          from_step_id: data.id,
        });
        history(`/${article_id}/${button.next_step_id}`);
        // const res = await API.getNewStep(article_id, data?.id, button.next_step_id);
        // setData(res);
        // setIsFirst(false);
      }
    }
  };

  const getStep = async () => {
    const res = await API.getStepById(article_id!, step_id!);
    setData(res);
  };

  useEffect(() => {
    getStep();
    window.scrollTo(0, 0);
  }, [article_id, step_id]);

  if (!data) return null;

  // if (type === "unclear" && article_id) {
  //   return <UnclearBlock article_id={article_id} step_id={data.id} setType={setType} />;
  // }

  if (type === "complaint" && article_id) {
    return <ComplaintBlock article_id={article_id} step_id={data.id} setType={setType} />;
  }

  if (type === "gratitude") {
    return <GratitudeBlock />;
  }

  if (data.type === "success" && article_id) {
    return <SuccessBlock article_id={article_id} step_id={data.id} setType={setType} />;
  }

  const shouldShowInformMessage = data.buttons.some((item) => item.type === "success") && data.type === "first";

  return (
    <div className="wrapper">
      <ContentTable
      // article_id={article_id} step_id={step_id}
      />
      <div>
        {shouldShowInformMessage && (
          <div className="info card">
            <div>❗❗❗</div>
            <div>
              Если инструкция на этом шаге вам ясна, и вы его выполнили, нажмите кнопку{" "}
              <span style={{ color: "blue", fontWeight: 500 }}>Понятно</span>.
            </div>
            <div>
              В противном случае нажмите <span style={{ fontWeight: 500 }}>Непонятно</span>.
            </div>
            {/* ❗ После выполнения каждого шага нажимайте синию кнопку <span style={{ color: "blue", fontWeight: 500 }}>Понятно</span>, 
          либо <span style={{ fontWeight: 500 }}>Непонятно</span>, если вы столкнулись со сложностями на этом шаге.{" "} */}
          </div>
        )}

        <div className="card">
          {/* <div className="card step_page"> */}
          <h2>{data.heading}</h2>
          <ReactMarkdown
            children={data.content}
            components={{
              img: ({ node, ...props }) => (
                <Zoom>
                  <img style={{ maxWidth: "100%" }} {...props} />
                </Zoom>
              ),
              code: ({ node, ...props }) => (
                <code
                  style={{
                    backgroundColor: "lightgoldenrodyellow",
                    padding: "1px 5px",
                    borderRadius: "1px",
                    fontWeight: 500,
                  }}
                  {...props}
                />
              ),
              h4: ({ node, ...props }) => <h4 style={{ marginBlockStart: "2em", marginBlockEnd: "0em" }} {...props} />,
              a: ({ node, ...props }) => (
                <a {...props} target="_blank">
                  {props.children}
                </a>
              ),
            }}
          />
          {!unclear && (
            <div className="buttons">
              {data.buttons.map((button) => (
                <button className={button.type} onClick={() => clickHandler(button)}>
                  {button.type === "success" && <span>&#10003;</span>} {button.name}
                </button>
              ))}
              {data.type === "step" || data.type === "first" ? (
                <button className="unclear" onClick={() => setUnclear(true)}>
                  &#215; Непонятно
                </button>
              ) : null}
            </div>
          )}
        </div>
        {unclear && <UnclearBlock article_id={article_id!} step_id={data.id} close={() => setUnclear(false)} />}
      </div>
    </div>
  );
};
